

<nav class="navbar navbar-expand-lg navbar-dark " >
    <div class="container">
       <a class="navbar-brand" href="#"><img src="assets/images/nav-logo.png" class="img-fluid"></a>
       <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
         <span class="navbar-toggler-icon"></span>
       </button>
     
       <div class="collapse navbar-collapse" id="navbarSupportedContent">
         <ul class="navbar-nav ml-auto">
           
          <li class="nav-item">
             <a class="nav-link" routerLink="home">HOME</a>
          </li>
          <li class="nav-item">
           <a class="nav-link" routerLink="menu">MENU</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="reservation">RESERVATION</a>
          </li>
          <li class="nav-item">
           <a class="nav-link" routerLink="pages">PAGES</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="recipe">RECIPE</a>
           </li>
          <li class="nav-item">
           <a class="nav-link" routerLink="blog">BLOG</a>
          </li>
          <li class="nav-item">
           <a class="nav-link" routerLink="contacts">CONTACTS</a>
          </li>
          
          <li class="nav-item">
           <a class="nav-link " routerLink="shopping"><i class="fas fa-shopping-cart"></i></a>
          </li>
           
          
           
         </ul>
         
       </div>
    </div>
   </nav>

  